<template>
  <teleport to="body">
    <dialog class="fixed inset-0 z-50" :open="isOpen" @close="close">
      <transition name="fade">
        <div v-if="isOpen" class="h-full w-full bg-black bg-opacity-25" @click="close"></div>
      </transition>

      <transition name="scale-up">
        <div v-if="isOpen" class="modal-content">
          <header v-if="!noHeader" class="p-4 pb-0">
            <slot name="header">Default Header</slot>
          </header>
          <section class="p-4">
            <slot name="content">Default Content</slot>
          </section>
          <footer class="flex justify-end items-center px-4 py-2 space-x-2 bg-gray-100 rounded-b-lg">
            <slot name="actions" :close="close">
              <button class="px-2 py-1.5 bg-blue-500 text-white rounded hover:bg-blue-600" @click="close">Close</button>
            </slot>
          </footer>
        </div>
      </transition>
    </dialog>
  </teleport>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  noHeader: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const isOpen = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newVal) => {
    isOpen.value = newVal;
  }
);

const close = () => {
  isOpen.value = false;
  emit('update:modelValue', false);
};

const open = () => {
  isOpen.value = true;
  emit('update:modelValue', true);
};

defineExpose({
  close,
  open,
});
</script>

<style scoped>
dialog::backdrop {
  background: transparent;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.scale-up-enter-active,
.scale-up-leave-active {
  transition:
    transform 0.2s ease-out,
    opacity 0.2s;
}

.scale-up-enter-from,
.scale-up-leave-to {
  transform: scale(0.95);
  opacity: 0;
}

.scale-up-enter-to,
.scale-up-leave-from {
  transform: scale(1);
  opacity: 1;
}

.modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 4px;
  min-width: 300px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}
</style>
